import React, { Component } from "react";

class Textarea extends Component {
  state = {
    formclass: "form-group custom-input",
  };

  handleFocus = () => {
    this.setState({ formclass: "form-group custom-input show on" });
  };

  handleBlur = (e) => {
    const classname = e.target.value
      ? "form-group custom-input show on"
      : "form-group custom-input";
    this.setState({ formclass: classname });
  };

  handleInput = () => {
  if (this.textarea) {
    this.textarea.style.height = "auto";
    this.textarea.style.height = `${this.textarea.scrollHeight}px`; 
    }
  };

  componentDidMount() {
    const classname = this.props.value
      ? "form-group custom-input show on"
      : "form-group custom-input";
    this.setState({ formclass: classname });

    if (this.textarea) {
    this.textarea.style.height = "auto";
    this.textarea.style.height = `${this.textarea.scrollHeight}px`;
   }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      const classname = this.props.value
        ? "form-group custom-input show on"
        : "form-group custom-input";
      this.setState({ formclass: classname });

    if (this.textarea) {
      this.textarea.style.height = "auto";
      this.textarea.style.height = `${this.textarea.scrollHeight}px`;
   }
    }
  }
  render() {
    const { name, label, error, ...rest } = this.props;
    return (
      <div className={this.state.formclass}>
        <label htmlFor={name}>{label}</label>
        <textarea
          name={name}
          id={name}
          className={error ? "form-control error" : "form-control"}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onInput={this.handleInput}
          ref={(el) => (this.textarea = el)}
          {...rest}
        />
        {error && <label className="error">{error}</label>}
      </div>
    );
  }
}

export default Textarea;
